import * as contentful from 'contentful'

export const client = contentful.createClient({
    space: 'zzfvjv34tabh',
    accessToken: '7ZrhQkgeTSC_EwPtJTDChEOg4vMT4IYvLOet4GKukEU'
})